import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { UserAuth } from './AuthContext';
import { requiresVerification, VERIFY_EMAIL_PATH } from './emailVerification.js';

// Auth + email gate for /signup + /onboarding, which sit outside ProtectedRoute.
//
// Anonymous visitors used to be let through, on the theory that the stepper was "reachable
// pre-auth". It is not usable pre-auth: every step needs `user.accessToken`, and the wizard's
// bootstrap returns immediately without one, leaving its own spinner on screen forever. That is
// what a signed-in user of one environment sees after editing the host in the address bar
// (dev.geoplay.io → qv.geoplay.io): Firebase sessions are per-origin, so the new host has none.
// Send them to sign in instead of leaving them on a spinner that will never resolve.
//
// Gated on authResolved, never on `!user` alone — see AuthContext: a fresh tab legitimately reads
// null for a moment before Firebase restores the origin's session.
export const RequireVerifiedEmail = ({ children }) => {
    const { user, authResolved } = UserAuth();
    const location = useLocation();

    if (!user && authResolved) {
        return <Navigate to="/account?mode=login" replace state={{ from: `${location.pathname}${location.search}` }} />;
    }

    if (requiresVerification(user)) {
        return <Navigate to={VERIFY_EMAIL_PATH} replace state={{ from: `${location.pathname}${location.search}` }} />;
    }

    return children ?? <Outlet />;
};

export default RequireVerifiedEmail;
